import { render } from "./search.vue?vue&type=template&id=7d50f53b&scoped=true&ts=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"

import "./search.vue?vue&type=style&index=0&id=7d50f53b&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d50f53b"]])

export default __exports__